var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.component.type}-container`},[_c(_vm.componentEditor,{tag:"component",attrs:{"component":_vm.component,"theme":_vm.theme[_vm.component.type],"is-global-content-item":_vm.isGlobalContentItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }